import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/workshop/workshop_procurement_orders`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_procurement_orders/${id}`, options)
    .then(response => {
      let procurement_order = jsona.deserialize(response.data);
      delete procurement_order.links;
      return procurement_order;
    });
}

function add(procurement_order) {
  
  const payload = jsona.serialize({
    stuff: procurement_order,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/workshop/workshop_procurement_orders`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(procurement_order) {
  const payload = jsona.serialize({
    stuff: procurement_order,
    includeNames: []
  });
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };
    
  console.log(procurement_order);
  // return axios.patch(`${url}/workshop/workshop_procurement_orders/${procurement_order.id}`, payload, options)
  return axios.patch(`${url}/workshop/workshop_procurement_orders/${procurement_order.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/workshop/workshop_procurement_orders/${id}`, options);
}

function update_status(procurement_orders) {
  const payload = jsona.serialize({
    stuff: procurement_orders,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/workshop/workshop_procurement_orders/update_status/${procurement_orders.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function last_no() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_procurement_orders/last/no`, options)
    .then(response => {
      return response.data;
    });
}

function input_payment(procurement_orders) {
  const payload = jsona.serialize({
    stuff: procurement_orders,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/workshop/workshop_procurement_orders/input_payment/${procurement_orders.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function input_invoice(procurement_orders) {
  const payload = jsona.serialize({
    stuff: procurement_orders,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/workshop/workshop_procurement_orders/input_invoice/${procurement_orders.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

export default {
  list,
  get,
  add,
  update,
  destroy,
  update_status,
  last_no,
  input_payment,
  input_invoice
};

